export interface InvoiceStatus {
  id: string;
  description: string;
  colour: string;
}
